<modal #modal>
    <div style="height: 605px;">
        <iframe [src]="frameUri | safe : 'resourceUrl'" width="100%" height="100%" scrolling="no" style="overflow-x:hidden;"></iframe>
    </div>
</modal>
